import styled from "styled-components";
import DownloadIconBase from "../../../DownloadIcon";

export const DownloadIconBaseStyled = styled(DownloadIconBase)`
  width: 20px;
  height: 20px;
  background: none;
`;
